import { useContext } from 'react';
import { SettingsEnvironmentContext } from './SettingsEnvironmentProvider';
export var useSettingsEnvironment = function () {
    var context = useContext(SettingsEnvironmentContext);
    if (!context) {
        throw new Error("`useSettingsEnvironment()` can't be used within a `Widget` component. Please use `useEnvironment()`");
    }
    return context;
};
//# sourceMappingURL=useSettingsEnvironment.js.map